(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product"]) return;
  try {
    
const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(productRecommendationsSection);

  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;

        $('.product-carousel-6').slick({
          adaptiveHeight: false,
          speed: 1000,
          prevArrow: '<button class="prev_arrow"><i class="fa fa-angle-left"></i></button>',
          nextArrow: '<button class="next_arrow"><i class="fa fa-angle-right"></i></button>',
        });

        setEqualProductHeights();

        // ⭐ FIX: INIT WISHLIST FOR AJAX LOADED PRODUCTS
        setTimeout(() => {
          const newButtons = document.querySelectorAll("[button-wishlist]");
          if (newButtons.length) setupButtons(newButtons);
        }, 300);
      }
    })
    .catch(e => console.error(e));
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
observer.observe(productRecommendationsSection);

// EQUAL HEIGHT FUNCTION
function setEqualProductHeights() {
  const cards = document.querySelectorAll('.product-carousel-6 .single_product');
  let rowTops = {};

  cards.forEach(card => card.style.height = 'auto');

  cards.forEach(card => {
    const top = card.getBoundingClientRect().top;
    if (!rowTops[top]) rowTops[top] = [];
    rowTops[top].push(card);
  });

  Object.values(rowTops).forEach(row => {
    let maxHeight = 0;
    row.forEach(card => { if (card.offsetHeight > maxHeight) maxHeight = card.offsetHeight; });
    row.forEach(card => card.style.height = maxHeight + 'px');
  });
}

window.addEventListener('load', setEqualProductHeights);
window.addEventListener('resize', setEqualProductHeights);
$('.product-carousel-6').on('setPosition', setEqualProductHeights);

  } catch(e) { console.error(e); }
})();
})();
